import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TermsOfServiceServiceProxy } from "@api/core";
import { PendingTermsOfService } from "@api/core.models";

@Injectable()
export class PendingTermsOfServiceSignatureService {
    constructor(private _api: TermsOfServiceServiceProxy) {}

    fetchUrl = async (url) => {
        const response = await fetch(url);
        return response.text();
    };

    checkForPendingTermsOfServiceSignature(): Observable<PendingTermsOfService> {
        return this._api.get();
    }

    sign(id: number): Observable<boolean> {
        return this._api.sign(id);
    }
}
